import MainPageSectionBrands from "../components/MainPageSections/MainPageSectionBrands";

import { Box, Flex } from "@chakra-ui/react";

import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import MainPageDiscoverSection from "../components/MainPageSections/MainPageDiscoverSection";
import MainPageNewsLetter from "../components/MainPageSections/MainPageNewsLetter";
// import MainPageStorylaneOverlay from "../components/MainPageSections/MainPageStorylaneOverlay";
import DemoBanner from "../components/DemoBanner/DemoBanner.js";

const MainPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [brandsLoaded, setBrandsLoaded] = useState(false);
  const [, setAboutUsLoaded] = useState(false);
  const [formLoaded, setFormLoaded] = useState(false);
  const [newsLetterLoaded, setNewsLetterLoaded] = useState(false);
  // const [firstVisit, setFirstVisit] = useState(false);

  useEffect(() => {
    (async () => {
      await import("../components/MainPageSections/MainPageSectionBrands");
      setBrandsLoaded(true);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await import("../components/MainPageSections/MainPageAboutUs");
      setAboutUsLoaded(true);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await import("../components/MainPageSections/MainPageForm");
      setFormLoaded(true);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await import("../components/MainPageSections/MainPageNewsLetter.js");
      setNewsLetterLoaded(true);
    })();
  }, []);

  // useEffect(() => {
  //   const checkFirstVisit = () => {
  //     const hasRun = sessionStorage.getItem("hasRun");
  //     if (hasRun) return;
  //     sessionStorage.setItem("hasRun", "true");
  //     const firstVisit = localStorage.getItem("firstVisit");
  //     if (!firstVisit) {
  //       localStorage.setItem("firstVisit", "true");
  //       // setFirstVisit(true);
  //       return;
  //     }
  //     localStorage.removeItem("firstVisit");
  //   };
  //   checkFirstVisit();
  // }, []);

  return (
    <Box position={'relative'} top={{base: '', xl: '30px'}}>
      <Helmet>
        <title>
          BulletScout | Compare Ammunition Prices, Find Cheap Ammo | 2025
        </title>
        <meta
          name="description"
          content="Premier ammo search engine for finding the cheapest ammunition prices online in 2025. Rifle, pistol, rimfire, and shotgun ammo in bulk."
        />
       
      </Helmet>
      <DemoBanner />
      {/* {firstVisit && <MainPageStorylaneOverlay />} */}
      <MainPageDiscoverSection />
      {brandsLoaded && <MainPageSectionBrands />}

      {formLoaded && newsLetterLoaded && (
        <Flex
          maxW={{ base: "", md: "7xl" }}
          mx={"auto"}
          justifyContent={"center"}
          mt={"50px"}
          mb={"60px"}
        >
          <MainPageNewsLetter />
        </Flex>
      )}
    </Box>
  );
};

export default MainPage;
